import { render } from "./SubprogramList.vue?vue&type=template&id=52a1d7eb&scoped=true"
import script from "./SubprogramList.vue?vue&type=script&lang=js"
export * from "./SubprogramList.vue?vue&type=script&lang=js"

import "./SubprogramList.vue?vue&type=style&index=0&id=52a1d7eb&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a1d7eb"]])

export default __exports__